import React from 'react';

import styles from './AdFlight.module.scss';
import {IProduct} from 'data/interfaces/products';
import FlightInfoSquare from '../flightInfoSquare/FlightInfoSquare';
import AdExitTime from '../adExitTime/AdExitTime';
import AdReturnTime from '../adReturnTime/AdReturnTime';
import AdTickets from '../../components/adTickets/AdTickets';
import AdCardStructureContainer from 'data/redux/containers/adCardStructureContainer';
import AirlineImageSquare from '../airlineImageSquare';
import AdAirlineCompany from '../../components/adAirlineCompany';


interface IAdProps {
  product: IProduct;

  view?: (id: number) => void
  edit?: (id: number) => void
  delete?: (id: number) => void


}

export const AdFlightCardDetails = props => <>
  <AdExitTime ticketDetails={props.product.ticketDetails}/>
  <AdReturnTime ticketDetails={props.product.ticketDetails}/>
  <AdAirlineCompany ticketDetails={props.product.ticketDetails}/>
  <AdTickets ticketDetails={props.product.ticketDetails}/>
</>;




const AdFlight = (props: IAdProps) => (
  <AdCardStructureContainer
    displaySquare={AirlineImageSquare}
    cardTitle={`${props.product.ticketDetails.originAirport.city} - ${props.product.ticketDetails.destinationAirport.city}`}
    specialDetails={<AdFlightCardDetails {...props}/>}
    specialDetails2={
      <FlightInfoSquare
        className={styles.flightInfoSquare}
        style={{backgroundColor: "transperent", height: "initial"}}
        showIcon={false}
        product={props.product}/>
    }
    salePriceLabel="מחיר לכל הכרטיסים"
    originalPriceLabel="מחיר מקורי"
    originalPrice={Math.floor(props.product.ticketDetails.currentAirlineAllTicketsPrice)}
    salePrice={Math.floor(props.product.saleDetails.askingPrice)}

    timeRemaining={props.product.ticketDetails.originTimeOfTakeOff}
    {...props}
  />
);

AdFlight.defaultProps = {
  product: {},


  hideControl: false,
  hideStatus: false,

  view: () => {
  },
  edit: () => {
  },
  delete: () => {
  },
};
export default AdFlight;
